var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platform"},[_c('div',{staticClass:"right"},[_c('div',{staticClass:"centre"},[_c('h1',{staticClass:"title"},[_vm._v("Data platform for wearables")])])]),_c('div',{staticClass:"centre"},[_c('div',{staticClass:"data"},[_c('div',{staticClass:"topic"},[_c('img',{attrs:{"src":require("@/assets/table.png")}})])])])])
}]

export { render, staticRenderFns }